import { AutogenLayoutCustomerQuickInfo } from "./autogen/AutogenLayoutCustomerQuickInfo";

export class CustomerQuickInfo extends AutogenLayoutCustomerQuickInfo {

}
